"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_URLS = void 0;
const constants_1 = require("./constants");
exports.API_URLS = {
    [constants_1.ENV.PROD]: 'https://backend.epns.io',
    [constants_1.ENV.STAGING]: 'https://backend-staging.epns.io',
    [constants_1.ENV.DEV]: 'https://backend-dev.epns.io',
    /**
     * **This is for local development only**
     */
    [constants_1.ENV.LOCAL]: 'http://localhost:4000',
};
//# sourceMappingURL=config.js.map